/**
 * This is the home of all scripts and snippets that should load
 * before the main bundle. It is a separate bundle from Webpack,
 * loaded before index.js.
 */
import { isProductionEnv } from "@eroad/helpers/isProductionEnv";
import { initSentry } from "@eroad/monitoring/sentry";

// We load sentry absolutely first so it can report if any errors
// occur in the following scripts.
if (isProductionEnv()) {
  initSentry({
    dsn: "https://730ad292cf7b4570887b609be3a9af81@o438049.ingest.sentry.io/4504012536414208",
    tracesSampleRate: 0.01,
  });
}
